function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var WinterTemplate = require('./winter.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WinterOverlay = /*#__PURE__*/function () {
  function WinterOverlay(app, mod) {
    _classCallCheck(this, WinterOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, true, false);
    this.stage = 'stage1';
  }
  return _createClass(WinterOverlay, [{
    key: "hide",
    value: function hide() {
      this.pushHudUnderOverlay();
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // skip showing on first round start
      if (this.mod.game.state.starting_round == this.mod.game.state.round) {
        return;
      }
      if (stage != '') {
        this.stage = stage;
      }
      var his_self = this.mod;
      this.overlay.show(WinterTemplate(stage));
      document.querySelector(".winter-text ul li.".concat(this.stage)).classList.add('active');
      if (stage == 'stage5' || stage == 'stage6' || stage == 'stage7' || stage == 'stage8') {
        try {
          document.querySelector('.saito-overlay .winter').style.backgroundImage = 'url(/his/img/backgrounds/diplomacy/ambassadors.jpeg)';
          document.querySelector('.saito-overlay .winter').style.backgroundSize = 'cover';
          document.querySelector('.saito-overlay .winter .winter-title').innerHTML = 'Diplomacy Phase';
          document.querySelector('.stage5').style.display = 'block';
          document.querySelector('.stage6').style.display = 'block';
          document.querySelector('.stage7').style.display = 'block';
          document.querySelector('.stage8').style.display = 'block';
          document.querySelector('.stage1').style.display = 'none';
          document.querySelector('.stage2').style.display = 'none';
          document.querySelector('.stage3').style.display = 'none';
          document.querySelector('.stage4').style.display = 'none';
        } catch (err) {}
      } else {
        document.querySelector('.saito-overlay .winter').style.backgroundImage = 'url(/his/img/backgrounds/winter_background.jpg)';
        document.querySelector('.saito-overlay .winter').style.backgroundSize = 'cover';
        document.querySelector('.saito-overlay .winter .winter-title').innerHTML = 'A Passage of Winter';
        document.querySelector('.stage1').style.display = 'block';
        document.querySelector('.stage2').style.display = 'block';
        document.querySelector('.stage3').style.display = 'block';
        document.querySelector('.stage4').style.display = 'block';
        document.querySelector('.stage5').style.display = 'none';
        document.querySelector('.stage6').style.display = 'none';
        document.querySelector('.stage7').style.display = 'none';
        document.querySelector('.stage8').style.display = 'none';
      }
      this.pullHudOverOverlay();
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var his_self = this.mod;
      $('.winter').on('click', function () {
        if (document.querySelector('#confirmit')) {
          $('#confirmit').click();
        }
      });
    }
  }]);
}();
module.exports = WinterOverlay;